module.exports = __webpack_public_path__ + "static/media/fingernail_left.14a932a5.svg";